/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import Table from './ChapterComponents/Table';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import PropTypes from "prop-types";
import {reorder,reArrange,reorderResourceInstances,titleArray,buildChapterPayload, getChapterId} from './HelperMethods/DragAndDropHelper';

export default class Chapters extends Component {
    /* eslint-disable react/sort-comp */

    static get propTypes() {
        return {
            activeCollection: PropTypes.object.isRequired,
            updateCollectionChapterInfo:PropTypes.func.isRequired,
            updateCollectionChapters:PropTypes.func.isRequired,
            deleteInstance:PropTypes.func.isRequired,
            removePart: PropTypes.func.isRequired,
            updateTitle: PropTypes.func.isRequired,
            createPart: PropTypes.func.isRequired,
            uploadFile: PropTypes.func.isRequired,
            resourceUploadData: PropTypes.object.isRequired,
            updateAdditionalResourceInfo: PropTypes.func.isRequired,
            resourceUploadSuccessDataEdit: PropTypes.func.isRequired,
            uploadContent: PropTypes.func.isRequired,
            clearAdditionalInfo: PropTypes.func.isRequired,
            closeModal: PropTypes.func.isRequired,
            getResource: PropTypes.func.isRequired
        };
    }

    constructor(props){
        super(props);
        const columns = props.activeCollection.chapters? reArrange(props.activeCollection.chapters): [];
        const chapterId = props.activeCollection.chapters? titleArray(props.activeCollection.chapters): [];
        this.state = {
            columns:props.activeCollection.chapters? columns : [],
            titles:props.activeCollection.chapters? Object.keys(columns) : [],
            chapterId:props.activeCollection.chapters? chapterId : [],
            freeze: false
        };
    }

    freezeDiv = (boolValue) => {
        this.setState({
            freeze:boolValue
        });
    };

    componentWillReceiveProps(nextProps){
        if(typeof nextProps.activeCollection.chapters === 'object'){
            const columns = nextProps.activeCollection.chapters? reArrange(nextProps.activeCollection.chapters): [];
            const chapterId = nextProps.activeCollection.chapters? titleArray(nextProps.activeCollection.chapters): [];
            if (nextProps.activeCollection.chapters !== this.props.activeCollection.chapters){
                this.setState({
                    columns:columns,
                    titles:Object.keys(columns),
                    chapterId:chapterId
                });
                this.freezeDiv(false);
            }
        }

    }

    onDragEnd = (result) => {
        // dropped nowhere
        if (!result.destination) {
            return;
        }

        const source = result.source;
        const destination = result.destination;

        // did not move anywhere - can bail early
        if (source.droppableId === destination.droppableId && source.index === destination.index) {
            return;
        }

        // reordering column
        if (result.type === 'COLUMN') {
            const titles = reorder(
                this.state.titles,
                source.index,
                destination.index
            );
            this.setState({
                titles: titles,
            });

            getChapterId(this.state.chapterId, result.draggableId);


            this.props.updateCollectionChapters(this.props.activeCollection.collectionId, getChapterId(this.state.chapterId, result.draggableId), result.destination.index);
            this.freezeDiv(true);
            return;
        }

        const data = reorderResourceInstances({
            resource: this.state.columns,
            source,
            destination,
            titles: this.state.titles
        });

        if (typeof data.titles === 'undefined'){
            this.setState({
                columns: data.resource
            });
            this.props.updateCollectionChapterInfo(this.props.activeCollection.collectionId, buildChapterPayload(this.state));
            this.freezeDiv(true);

        }else{
            this.setState({
                columns: data.resource,
                titles: data.titles
            });
            this.props.updateCollectionChapterInfo(this.props.activeCollection.collectionId, buildChapterPayload(this.state));
            this.freezeDiv(true);
        }
    };

    deleteChapterInstance = (instance) => {
        this.freezeDiv(true);
        this.props.deleteInstance(this.props.activeCollection.collectionId,instance);
    };

    render() {

        const columns = this.state.columns;
        const titles = this.state.titles;

        const board = (
            <Droppable
                droppableId="board"
                type="COLUMN"
                direction="vertical"
            >
                {(provided) => (
                    <div >
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {titles.map((title, index) => (
                                <Table
                                    updateTitle = {this.props.updateTitle}
                                    deleteInstance = {this.deleteChapterInstance}
                                    freezeUi = {this.freezeDiv}
                                    key={title}
                                    index={index}
                                    title={title}
                                    resourceIns={columns[title]}
                                    chapterId={columns[title].chapterId}
                                    chapterCount = {titles.length}
                                    removePart = {this.props.removePart}
                                    collectionId = {this.props.activeCollection.collectionId}
                                    collectionType = {this.props.activeCollection.collectionType}
                                    createPart = {this.props.createPart}
                                    showAddContentComponent = {this.props.showAddContentComponent}
                                    showAddOM3PComponent = {this.props.showAddOM3PComponent}
                                    activeCollection={this.props.activeCollection}
                                    uploadFile={this.props.uploadFile}
                                    resourceUploadData={this.props.resourceUploadData}
                                    updateAdditionalResourceInfo={this.props.updateAdditionalResourceInfo}
                                    resourceUploadSuccessDataEdit={this.props.resourceUploadSuccessDataEdit}
                                    uploadContent={this.props.uploadContent}
                                    clearAdditionalInfo={this.props.clearAdditionalInfo}
                                    closeModal={this.props.closeModal}
                                    getResource={this.props.getResource}
                                    clearResource={this.props.clearResource}
                                />
                            ))}</div>
                    </div>
                )}
            </Droppable>
        );

        return (
            <div>
                <div className={this.state.freeze?"DragAndDropZone freeze": "DragAndDropZone" }>
                    <div className={this.state.freeze? "loader":"hideLoader"}></div>
                    <DragDropContext
                        onDragStart={this.onDragStart}
                        onDragEnd={this.onDragEnd}
                    >
                        {board}
                    </DragDropContext>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/Chapters.js